export class PlaceAutoCompleteEntry {
    placeId!: string;
    description!: string;
    primaryText!: string;
    secondaryText!: string;
    icon!: string;
}
